import {Expose} from 'class-transformer';

export class PickupTimeStatusApiModel {
  @Expose()
  status: number = null;
}
